import moment from 'moment';

/**
 * A directive that applies scaling and offsets depending on the input timeslot
 * and timescale. The directive assumes scaling is relative to the element's
 * container size.
 */
export function SchedulerTimeslotOffsetDirective() {
    return {
        restrict: "A",
        scope: false,
        link: function(scope, el, attr) {
            scope.$watch(attr.timeslot, adjustScaling, true);
            scope.$watch(attr.start, adjustScaling);
            scope.$watch(attr.end, adjustScaling);
            scope.$watch(attr.scale, adjustScaling);

            adjustScaling();

            function adjustScaling() {
                const timeslot = scope.$eval(attr.timeslot);
                const start = scope.$eval(attr.start);
                const end = scope.$eval(attr.end);
                const scale = scope.$eval(attr.scale || "'day'");

                const scaleRange = moment(end).endOf(scale)
                    .diff(moment(start).startOf(scale), "hours", true);

                if (!scaleRange) {
                    console.warn("Invalid scale range:", start, end);
                    return;
                }

                let timeslotStart, timeslotEnd;
                if (timeslot.allDay) {
                    timeslotStart = moment(timeslot.startDateTime).startOf(scale);
                    timeslotEnd = moment(timeslot.endDateTime).endOf(scale);
                } else {
                    timeslotStart = moment(timeslot.startDateTime);
                    timeslotEnd = moment(timeslot.endDateTime);
                }
                // Snap time slot start and end dates to within the date range.
                timeslotStart = timeslotStart.isBefore(start, "day") ? moment(start) : timeslotStart;
                timeslotEnd = timeslotEnd.isAfter(end, "day") ? moment(end).endOf("day") : timeslotEnd;
                const timeSlotHours = timeslotEnd.diff(timeslotStart, "hours", true);

                const offsetFactor = Math.max(0, timeslotStart.diff(start, "hours") / 24);
                const widthFactor = Math.min(timeSlotHours / 24, scaleRange / 24);

                // Normalize time slot start in terms of the scale range.
                // Note, 100% = 24 hours.
                // Offset by 1px due to border on one side. TODO: Handle this in box model.
                const startOffset = `calc(-1px + (100% + 1px) * ${offsetFactor}`;
                const widthPercent = `calc((100% + 1px) * ${widthFactor})`;
                scaleElement(startOffset, widthPercent)
            }

            function scaleElement(offset, width) {
                el[0].style.marginLeft = offset;
                el[0].style.width = width;
            }
        }
    };
}
